<body>
    <!--<app-nav-menu></app-nav-menu>-->
<!--    <div class="container">
        <app-home-new></app-home-new>
    </div>-->
    <ngx-toastr></ngx-toastr>
    <!-- px-0: full-bleed dashboard canvas (Lovable: min-h-screen bg-background edge-to-edge). -->
    <div class="container-fluid display-height-100 px-0">
        <router-outlet></router-outlet>
    </div>
    <!--<script src="~/js/jquery.min.js"></script>
    <script src="~/js/popper.js"></script>
    <script src="~/js/bootstrap.min.js"></script>
    <script src="~/js/main.js"></script>-->
</body>
